import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {CustomerService} from "../../../services-otc/customer.service";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {CustomerAltAddressDto} from "../../../dto-otc/customer-alt-address-dto";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {catchError, throwError} from "rxjs";

@Component({
    selector: 'app-add-alt-address',
    templateUrl: './add-alt-address.component.html',
    styleUrls: ['./add-alt-address.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddAltAddressComponent {

  newAltAddressForm: FormGroup;
  newAltCustomerAddress: CustomerAltAddressDto;

constructor( @Inject(MAT_DIALOG_DATA) public data: any,
    private customerService: CustomerService,
    private altAddressFb: FormBuilder,
    public dialogRef: MatDialogRef<OrderComponent>,
) {

  this.newAltAddressForm = this.altAddressFb.group({
    addressLine1:new FormControl(''),
    addressLine2: new FormControl(''),
    addressLine3: new FormControl(''),
    town: new FormControl(''),
    province: new FormControl(''),
    postalCode: new FormControl(''),
  });
}

cancelAddingAltAddress(){
  this.dialogRef.close();
}
  addNewAltAddress() {
    this.newAltCustomerAddress = {
      addressLine1: this.newAltAddressForm.get('addressLine1').value,
      addressLine2: this.newAltAddressForm.get('addressLine2').value,
      addressLine3: this.newAltAddressForm.get('addressLine3').value,
      town: this.newAltAddressForm.get('town').value,
      province: this.newAltAddressForm.get('province').value,
      postalCode:this.newAltAddressForm.get('postalCode').value,
  }
    this.customerService.postNewCustomerAltAddress(this.newAltCustomerAddress,this.data.tenantId).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
    ).subscribe(response => {
          this.newAltCustomerAddress = response;
          this.dialogRef.close();
        });
  }
}
